module.exports = __webpack_public_path__ + "static/img/tag.0404e22.png";